import { PresetsPage } from './presets.page';

export default PresetsPage;
